import React from 'react';
import { Sparkles } from 'lucide-react';
interface OrderBumpProps {
  isBumpSelected: boolean;
  setIsBumpSelected: (val: boolean) => void;
}
export function OrderBump({
  isBumpSelected,
  setIsBumpSelected
}: OrderBumpProps) {
  return <div className="max-w-3xl mx-auto mt-8 mb-8 px-4" data-id="element-98">
      <div className="bg-gradient-to-br from-yellow-50 to-yellow-100/50 p-1 rounded-[20px]" data-id="element-99">
        <div className={`relative bg-white rounded-[20px] p-6 transition-all duration-300 cursor-pointer shadow-lg ${isBumpSelected ? 'ring-2 ring-brand-teal ring-offset-2' : 'hover:shadow-xl'}`} onClick={() => setIsBumpSelected(!isBumpSelected)} data-id="element-100">
          <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-101">
            {/* Image on the left */}
            <div className="flex-shrink-0 w-full md:w-32" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/api8pp2fYzuYrxpaGXSkFH/nuevobump.png" alt="El Código del Silencio" className="w-full h-auto rounded-[12px] shadow-md" data-id="element-103" />
            </div>

            <div className="flex-grow" data-id="element-104">
              <div className="flex items-center gap-2 mb-3" data-id="element-105">
                <Sparkles className="w-5 h-5 text-brand-gold" data-id="element-106" />
                <h4 className="font-bold text-red-600 text-sm sm:text-base uppercase tracking-wide" data-id="element-107">
                  ✨ OFERTA FLASH
                </h4>
              </div>

              <p className="text-gray-900 font-bold mb-2 text-base sm:text-lg" data-id="element-108">
                Evite destrozos y quejas de vecinos cuando usted sale de casa.
              </p>

              <p className="text-gray-600 text-sm mb-4" data-id="element-109">
                Añada{' '}
                <span className="font-bold text-gray-800" data-id="element-110">
                  EL CÓDIGO DEL SILENCIO
                </span>{' '}
                por solo{' '}
                <span className="font-bold text-brand-teal text-base" data-id="element-111">
                  $4.90 USD
                </span>{' '}
                <span className="text-red-600 font-semibold" data-id="element-112">(-85% OFF)</span>
              </p>

              {/* iOS-Style Toggle Switch */}
              <div className="flex items-center gap-3" data-id="element-113">
                <div className={`relative w-14 h-8 rounded-full transition-colors duration-300 ${isBumpSelected ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-114">
                  <div className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300 ${isBumpSelected ? 'translate-x-6' : 'translate-x-0'}`} data-id="element-115"></div>
                </div>
                <span className="text-sm font-semibold text-gray-700" data-id="element-116">
                  {isBumpSelected ? 'Añadido al pack' : 'Añadir al pack'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}